import React from 'react';
import './video.scss';
import ReactPlayer from 'react-player';

/**
 * Componente de soporte de video de youtube: video de tutorial caleta en línea
 *
 */
const YoutubeVideoOverlay = (props) => {
    return (
        <div className={props.ShowOverlay ? " OverlayContainer ShowOverlay" : "OverlayContainer HiddenOverlay"} onClick={() => { props.SetShowOverlay(false);document.body.style.overflow = 'auto'; }} >
            <div className="VideoContainer" >
                <ReactPlayer playing={props.ShowOverlay} controls className="Video" width="100%" height="100%" url="https://youtu.be/4fy4WbX9f0o"></ReactPlayer>
            </div>
        </div>
    );
}

export default YoutubeVideoOverlay;
// onClick={() => SetShowOverlay(false)}